export const getCountryCodeByCurrency = (currencyCode: string) => {
    if (currencyCode === 'EUR') {
        return 'EU';
    }

    return currencyCode.slice(0, 2);
};
